<template>
    <div class="footer-content-flex flex xl:flex-no-wrap lg:flex-wrap md:flex-wrap justify-between">
        <!-- Footer Common links -->
        <div class="footer-widget widget-logo xl:mb-0 lg:mb-0 md:mb-spc27">
            <div v-if="logosrc" class="footer-logo mb-spc57">
                <Logo :imgsrc="logosrc" link="/" />
            </div>
            <FooterLinks :footerlink="footerlinkswidget.commonlinks" />
        </div>
        <!-- Footer Resources links -->
        <div class="footer-widget widget-resource xl:mb-0 lg:mb-0 md:mb-spc27">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerResource}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.resource" />
        </div>
        <!-- Footer Product links -->
        <div class="footer-widget widget-product xl:mb-0 lg:mb-0 md:mb-spc27">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerProduct}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.products" />
        </div>
        <!-- Footer Support links -->
        <div class="footer-widget widget-support xl:mb-0 lg:mb-0 md:mb-spc27">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerSupport}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.support" />
        </div>
        <!-- Footer Company links -->
        <div class="footer-widget widget-company xl:mb-0 lg:mb-0 md:mb-spc27">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerCompany}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.companies" />
        </div>
        <!-- Footer Contact links -->
        <div class="footer-widget widget-contact xl:mb-0 lg:mb-0 md:mb-spc27">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerContact}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.contact" />
        </div>
        <!-- Footer Platform links -->
        <div class="footer-widget widget-platform">
            <h2 class="text-white text-base font-bold leading-6 tracking-spc1 mb-spc58 mt-spc36">
                {{footerPlatform}}
            </h2>
            <FooterLinks :footerlink="footerlinkswidget.platform" />
        </div>

    </div>
</template>

<script>
    import Logo from "./Logo";
    import FooterLinks from "./widgets/FooterLinks";

    /* footer common links */
    let footerlinkswidget = {
        commonlinks: [
            {
                title: 'Privacy Policy',
                path: '#',
                newTag: ""
            },
            {
                title: 'Cookie Policy',
                path: '#',
                newTag: ""
            },
            {
                title: 'Terms of Service',
                path: '#',
                newTag: ""
            },
            {
                title: 'GDPR Commitment',
                path: '#',
                newTag: ""
            },
        ],
        resource: [
            {
                title: 'Templates',
                path: '#',
                newTag: "new"
            },
            {
                title: 'API Docs',
                path: '#',
                newTag: ""
            },
            {
                title: 'Affiliates',
                path: '#',
                newTag: ""
            },
            {
                title: 'Partnerships',
                path: '#',
                newTag: ""
            },
            {
                title: 'Perks & Benefits',
                path: '#',
                newTag: ""
            },
        ],
        products: [
            {
                title: 'Pricing',
                path: '#',
                newTag: ""
            },
            {
                title: 'Features',
                path: '#',
                newTag: ""
            },
            {
                title: 'Apps',
                path: '#',
                newTag: "new"
            },
            {
                title: 'Roadmap',
                path: '#',
                newTag: ""
            },
        ],
        support: [
            {
                title: 'Help Center',
                path: '#',
                newTag: ""
            },
            {
                title: 'Experts',
                path: '#',
                newTag: "new"
            },
            {
                title: 'Contact Us',
                path: '#',
                newTag: ""
            },
            {
                title: 'Community',
                path: '#',
                newTag: ""
            },
        ],
        companies: [
            {
                title: 'About',
                path: '#',
                newTag: ""
            },
            {
                title: 'Our Blog',
                path: '#',
                newTag: ""
            },
            {
                title: 'In the Press',
                path: '#',
                newTag: ""
            },
            {
                title: 'Brand Assets',
                path: '#',
                newTag: ""
            },
            {
                title: 'Careers',
                path: '#',
                newTag: ""
            },
            {
                title: 'Online Store',
                path: '#',
                newTag: ""
            },
        ],
        contact: [
            {
                title: 'Facebook',
                path: '#',
                newTag: ""
            },
            {
                title: 'Twitter',
                path: '#',
                newTag: ""
            },
            {
                title: 'Youtube',
                path: '#',
                newTag: ""
            },
            {
                title: 'Instagram',
                path: '#',
                newTag: ""
            },
            {
                title: 'Dribbble',
                path: '#',
                newTag: ""
            },
        ],
        platform: [
            {
                title: 'iPhone & iPad',
                path: '#',
                newTag: ""
            },
            {
                title: 'Android',
                path: '#',
                newTag: ""
            },
            {
                title: 'MacOS',
                path: '#',
                newTag: ""
            },
            {
                title: 'Windows',
                path: '#',
                newTag: ""
            },
        ],
    }

    export default {
        name: "ThemeFooter",
        components: {
            Logo,
            FooterLinks,
        },
        data() {
            return {
                footerlinkswidget,
                logosrc: require('@/assets/images/logo.svg'),
                footerResource: "Resources",
                footerProduct: "Product",
                footerSupport: "Support",
                footerCompany: "Company",
                footerContact: "Contact",
                footerPlatform: "Platform",
            }
        }
    }
</script>

<style scoped>

</style>